import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Layout } from 'antd';

import { RootState } from 'store';
import usePageContainerMinHeight from 'utils/CustomHooks/usePageContainerMinHeight';
import BaseLayoutSideBar from './baseLayoutSideBar/BaseLayoutSideBar';
import BaseLayoutHeader from './baseLayoutHeader/BaseLayoutHeader';

import './BaseLayout.scss';

const { Content } = Layout;

interface Props {
  children: ReactNode;
  className?: string;
}

function BaseLayout(props: Props) {
  const { children, className } = props;
  const { sideBarCollapsed, sideBarWidth, sideBarCollapsedWidth } = useSelector(
    (state: RootState) => state.baseLayoutSettings
  );
  const pageContainerMinHeight = usePageContainerMinHeight();

  return (
    <Layout className="BaseLayout">
      <BaseLayoutSideBar />
      <Layout
        className="BaseLayout__container"
        style={{
          minHeight: pageContainerMinHeight,
          paddingLeft: `${
            sideBarCollapsed ? sideBarCollapsedWidth : sideBarWidth
          }px`,
        }}
      >
        <BaseLayoutHeader />
        <Content className={`BaseLayout__content ${className || ''}`}>
          {children}
        </Content>
      </Layout>
    </Layout>
  );
}

export default BaseLayout;
